// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f61739ee","498":"2af6abdc","703":"52ea1618","787":"6e286c19"}[chunkId] + ".chunk.js";
};